<div class="ir-mask-menuroll th-menuselect">
  <div class="ir-row">
    <div *ngIf="search" class="centered-modal" style="max-height: 500px; overflow-y: auto">
      <div class="ir-btn ir-btn--big th-btn-menuroll">
        <input
          autofocus
          focus="showSearch"
          class="ir-form-set"
          type="search"
          name="Search"
          placeholder="{{ 'common.placeholders.search' | translate }}"
          [(ngModel)]="query"
        />
      </div>
      <div
        class="ir-btn ir-btn--big menu-button"
        *ngFor="let item of selectorValues | searchBy : query; let i = index"
        (click)="updateSelected(item)"
        [ngClass]="item.selected ? 'th-btn-normal' : 'th-btn-menuroll'"
      >
        <span>{{ item.label ? item.label : item }}</span>
      </div>
    </div>
    <div *ngIf="!search" class="centered-modal" style="max-height: 500px; overflow-y: auto">
      <div
        class="ir-btn ir-btn--big menu-button"
        *ngFor="let item of selectorValues; let i = index"
        (click)="updateSelected(item)"
        [ngClass]="item.selected ? 'th-btn-normal' : 'th-btn-menuroll'"
      >
        <span>{{ item.label ? item.label : item }}</span>
      </div>
    </div>
  </div>
</div>
